/* import __COLOCATED_TEMPLATE__ from './markdown-to-html.hbs'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable  prettier/prettier, no-prototype-builtins */

import showdown from 'showdown';
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';
import { getOwner } from '@ember/application';
const CONFIG_LOOKUP = 'config:environment';
export default class ShowdownComponent extends Component {
  get defaultOptionKeys() {
    return Object.keys(showdown.getDefaultOptions());
  }
  constructor() {
    super(...arguments);
    _defineProperty(this, "_globalOptions", null);
    const owner = getOwner(this);
    if (owner && owner.hasRegistration(CONFIG_LOOKUP)) {
      this._globalOptions = (owner.resolveRegistration(CONFIG_LOOKUP) || {}).showdown;
    }
  }
  get html() {
    let showdownOptions = this.getShowdownProperties(this.defaultOptionKeys);
    let converter = this.converter;
    for (let option in showdownOptions) {
      if (showdownOptions.hasOwnProperty(option) && typeof showdownOptions[option] !== 'undefined') {
        converter.setOption(option, showdownOptions[option]);
      }
    }
    return htmlSafe(converter.makeHtml(this.args.markdown));
  }
  get converter() {
    let extensions = this.args.extensions ?? [];
    if (typeof extensions === 'string') {
      extensions = extensions.split(' ');
    }
    return new showdown.Converter({
      extensions
    });
  }
  getShowdownProperties(keyNames) {
    return keyNames.reduce((accumulator, keyName) => {
      let value = this.args[keyName];
      if (value === undefined && this._globalOptions) {
        value = this._globalOptions[keyName];
      }
      accumulator[keyName] = value;
      return accumulator;
    }, {});
  }
}